import { MutationTree } from 'vuex'
import { AccountApi, AccountState, StoreError } from './types'

export const mutations: MutationTree<AccountState> = {
  ACCOUNT_LOGIN (state, payload: AccountApi) {
    state.error = { state: false }
    state.access_token = payload.access_token
    state.aceptar_tyc = payload.aceptar_tyc
    state.alerta_correo = payload.alerta_correo
    state.alerta_movil = payload.alerta_movil
    state.correo = payload.correo
    state.id = payload.id
    state.region_list = payload.region_list
    state.tyc = payload.tyc
  },
  ACCOUNT_LOGOUT (state) {
    state.error = { state: false }
    state.tyc = 0
    state.aceptar_tyc = true
    state.correo = ''
    state.alerta_correo = ''
    state.access_token = ''
    state.id = 1
    state.alerta_movil = ''
    state.region_list = []
  },
  ACCOUNT_ERROR (state, payload: StoreError) {
    state.error = payload
  },
  PASSWORD_UPDATED (state, payload) {
    state.passwordUpdate = {
      status: payload.statusCode,
      timestamp: Date.now()
    }
  },
  ALERT_UPDATED (state, payload) {
    console.log`hola: ${payload}`
    state.alertUpdate.status = payload.statusCode
    state.alertUpdate.timestamp = Date.now()
    if (payload.statusCode === 200) {
      state.alerta_movil = payload.alertaMovil
      state.alerta_correo = payload.alertaCorreo
    }
  }
}
